import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PrivilegesProviderService } from '@bayclubs/utils';

import { PrivilegesApiService } from './privileges.api.service';

@Injectable()
export class ManagementPrivilegesProviderService extends PrivilegesProviderService {
    public scope = 'GroupClasses';

    constructor(private privileges: PrivilegesApiService) {
        super();
    }

    getPrivileges(): Observable<any> {
        return this.privileges.get();
    }
}
